import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly defaultLang = 'es';
  private readonly storageKey = 'preferredLang';

  constructor(private translate: TranslateService) {
    const savedLang = localStorage.getItem(this.storageKey);
    const browserLang = this.translate.getBrowserLang();

    const initialLang = savedLang || (browserLang?.match(/en|es/) ? browserLang : this.defaultLang);
    this.setLanguage(initialLang);
  }

  setLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem(this.storageKey, lang);
  }

  getCurrentLanguage(): string {
    const lang = localStorage.getItem(this.storageKey);
    return lang === 'en' || lang === 'es' ? lang : this.defaultLang;
  }

}
